export interface IHttp {
  get<T>(url: string): Promise<T>;

  post<T>(url: string, data: object): Promise<T>;
}

export class Http implements IHttp {
  /**
   * Initializes a new instance of the HTTP interactor class.
   */
  constructor() {}

  /** Makes GET request to the provided URL and returns received data.*/
  async get<T>(url: string): Promise<T> {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return (await response.json()) as T;
  }

  /** Makes POST request to the provided URL and returns received data. */
  async post<T>(url: string, data: object): Promise<T> {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    return (await response.json()) as T;
  }
}
